<template>
  <card>
    <div class="row"> 
      <div class="col-6">
        <div class="row no-gutters">
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('Tarix') }}</div>
          <div class="col-8 pd value">{{ item.callDateStr }}</div>
          
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('Sığortalı_nömrə') }}</div>
          <div class="col-8 pd value">{{ item.phone }}</div>
          
          <div v-if="item.policyType === 1" :class="['col-4', textLeft, 'pd label']">{{ $t('Sığortalı_DQN') }}</div>
          <div v-if="item.policyType === 1" class="col-8 pd value">{{ item.regNumber }}</div>
          
          <div v-if="item.policyType === 1" :class="['col-4', textLeft, 'pd label']">{{ $t('Sığortalı_marka_model') }}</div>
          <div v-if="item.policyType === 1" class="col-8 pd value">{{ item.customBrandModel }}</div>
          
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('SŞ') }}</div>
          <div class="col-8 pd value">{{ item.policyNumber }}</div>
          
          <div :class="['col-4', textLeft, 'pd label']" v-if="item.policyType==null || item.policyType==1 || item.policyType==2">{{ $t('Qəza_komissarı') }}</div>
          <div class="col-8 pd value" v-if="item.policyType==null || item.policyType==1 || item.policyType==2">{{ item.accidentCommUserName }}</div>
        </div>
      </div>
      <div class="col-6">
        <div class="row no-gutters">
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('Hadisənin_vaxtı') }}</div>
          <div class="col-8 pd value">{{ item.accidentDateStr }}</div>
          
          <div v-if="item.policyType === 1" :class="['col-4', textLeft, 'pd label']">{{ $t('Sürücü') }}</div>
          <div v-if="item.policyType === 1" class="col-8 pd value">
            <span v-if="item.driverNoInfo" class="red-bold">{{ $t('Məlumat_yoxdur') }}</span>
            <span v-else>{{ item.driver }}</span>
          </div>
          
          <div v-if="item.policyType === 1" :class="['col-4', textLeft, 'pd label']">
            {{ !item.driverNoInfo ? $t('Sürücü_nömrəsi') : $t('Məlumat_olmama_səbəbi') }}
          </div>
          <div v-if="item.policyType === 1" class="col-8 pd value">{{ !item.driverNoInfo ? item.driverPhone : item.driverDescr }}</div>

          <div :class="['col-4', textLeft, 'pd label']">{{ $t('Sığorta_müddəti') }}</div>
          <div class="col-8 pd value">{{ item.insurancePeriod !== ' - ' ? item.insurancePeriod : item.volInsurancePeriod }}</div>
          
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('Rayon') }}</div>
          <div class="col-8 pd value">{{ item.regionName }}</div>
          
          <div :class="['col-4', textLeft, 'pd label']">{{ $t('Hadisə_yeri') }}</div>
          <div class="col-8 pd value">{{ item.place }}</div>
        </div>
      </div>
    </div>

    <div class="row no-gutters" style="padding-top: 3px">
      <div :class="['col-2', textLeft, 'pd label']">{{ $t('Təfərrüat') }}</div>
      <div class="col-10 pd value">{{ item.descr }}</div>
    </div>
    
    <div class="col-12" style="padding-top: 3px">
      <record-label :created="item.createdBy" :updated="item.updatedBy" />
    </div>
  </card>
</template>

<script>
import RecordLabel from "./RecordLabel.vue";
import { textLeft } from "../../services/helper";

export default {
  components: {
    RecordLabel,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      item: this.value,
      textLeft: textLeft,
    };
  },
  watch: {
    value() {
      this.item = this.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.no-gutters {
  margin-right: 0;
  margin-left: 0;
  
  > .col,
  > [class*="col-"] {
    padding-right: 0;
    padding-left: 0;
  }
}

.label {
  font-weight: bold;
  color:#3A3A3A !important;
 font-size: var(--font-primary);
}

.value {
  color: #333;
}

.red-bold {
  color: red;
  font-weight: bold;
}
</style>